// ── v1.1 per-page title + description (SEO_META_ENABLED) ──────────────────────
import { useEffect } from "react";
import { useLaunchConfig } from "./launch-config";

export function usePageMeta(title: string, description?: string): void {
  const { flags } = useLaunchConfig();
  useEffect(() => {
    if (!flags.seoMeta) return;
    const prevTitle = document.title;
    document.title = title;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    const prevDesc = meta?.content;
    if (description) {
      if (!meta) { meta = document.createElement("meta"); meta.name = "description"; document.head.appendChild(meta); }
      meta.content = description;
    }
    return () => { document.title = prevTitle; if (meta && prevDesc !== undefined) meta.content = prevDesc; };
  }, [flags.seoMeta, title, description]);
}
